import React, { useEffect, useState } from "react";
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import moment from "moment";
import CardBody from "../../views/Card/CardBody.js";
import style from "./styles.module.css";
import IconButton from "@material-ui/core/IconButton";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import Tooltip from "@material-ui/core/Tooltip";
import Snackbar from "../utils/snackbar/Snackbar";
import { withRouter } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { Pagination } from "@material-ui/lab";
import { getData } from "../../restfulservices/httpHandler.js";
import EditWithdrawModal from "./Modal/EditWithdrawModal.js";

const AllRequests = (props) => {
  const [filteredData, setFilteredData] = useState([]);
  const [categoryCount, setCategoryCount] = useState(null);
  const [alert, setAlert] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [activeUser, setActiveUser] = useState(null);
  const [page, setPage] = useState(1);
  let limit = 10;

  useEffect(() => {
    fetchCategory();
  }, [alert, page]);

  const fetchCategory = async () => {
    const res = await getData(
      `v1/ticket/getAllWithdraw?page=${page}&limit=${limit}`
    );
    setFilteredData(res?.data?.data?.history || []);
    setCategoryCount(res?.data?.data?.count);
  };

  const formatDate = (date) => {
    return moment(date).format("MMM Do YY");
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const details = [];

  filteredData?.forEach((val, index) => {
    details.push([
      index + 1,
      val?.userId?.name,
      val?.status,
      val?.withdrawBy,
      formatDate(val.createdAt),
      <React.Fragment>
        <Tooltip title="Edit">
          <IconButton
            onClick={() => {
              setActiveUser(val);
              setEditModal(true);
            }}
          >
            <EditRoundedIcon />
          </IconButton>
        </Tooltip>
      </React.Fragment>,
    ]);
  });

  return (
    <GridContainer>
      {activeUser && (
        <EditWithdrawModal
          type="EDIT"
          userData={activeUser}
          open={editModal}
          onClose={() => setEditModal(false)}
          onDone={() => {
            setEditModal(false);
            setActiveUser(null);
            fetchCategory(); // Refresh the data after editing
          }}
          setAlert={(msg) => setAlert(msg)}
        />
      )}
      <Snackbar open={alert} handleClose={() => setAlert(false)} />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>Payment History</h4>
            </div>
          </CardHeader>
          <CardBody>
            {!filteredData.length && (
              <div className={style.loader}>
                <CircularProgress />
              </div>
            )}

            {filteredData.length > 0 && (
              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "S.N",
                  "Name",
                  "Status",
                  "Withdraw By",
                  "Payment Date",
                  "Action",
                ]}
                tableData={details}
              />
            )}
          </CardBody>
        </Card>
      </GridItem>
      <div
        style={{ width: "100vw", display: "flex", justifyContent: "center" }}
      >
        <Pagination
          count={Math.ceil(parseInt(categoryCount) / limit)}
          page={page}
          onChange={handleChangePage}
        />
      </div>
    </GridContainer>
  );
};

const mapStateToProps = (state) => ({
  user: state.appReducer.user,
});

export default withRouter(connect(mapStateToProps)(AllRequests));
